export const USER_ROLES_ENUM = {
  admin: "admin",
  user: "user",
};

export const NETWORK_PROVIDER_ENUMS = [
{
  name: "MTN",  
  value: "MTN",
},
{
  name: "Jazz",  
  value: "jazz",
},
{
  name: "Warid",  
  value: "warid",
},
{
  name: "Zong",  
  value: "zong",
},

]
export const GATEWAY_ENUM = [
  { name: "Stripe", value: "stripe" },
  { name: "Converge", value: "converge" },
  { name: "Fluid Pay", value: "fluid_pay" },
  { name: "I Can Pay", value: "i_can_pay" },
  { name: "Non Bank", value: "non_bank" },
  { name: "Bolt Pay", value: "bolt_pay" },
  { name: "Slot", value: "slot" },
  { name: "Ficer", value: "ficer" },
  { name: "knox Payments", value: "knox_payments" },
  { name: "Total Pay", value: "total_pay" },
  { name: "Payment Technologies", value: "payment_technologies" },
  { name: "Mentom Pay", value: "mentom_pay" },
];

export const SERVICE_PROVIDER_ENUM = [
  { name: " Betting", value: "betting" },
  { name: " Utility Bill", value: "utility_bill" },
  { name: " Cable", value: "cable" },
  { name: " Airtime", value: "airtime" },
  { name: " Data", value: "data" },
  { name: " Airtime", value: "airtime" },
  { name: " Other Bills Payment", value: "other_bills_payment" },
];
